import { render, staticRenderFns } from "./kcontentrenderer.vue?vue&type=template&id=6ecbdcc6&scoped=true&"
import script from "./kcontentrenderer.vue?vue&type=script&lang=js&"
export * from "./kcontentrenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecbdcc6",
  null
  
)

export default component.exports